import {getRedirectUri} from '@/pages/User/pages/VerifyLinkedinAuthentication/hooks/utils';
import {LINKEDIN_API_CONFIG} from './constants';

export const getLinkedinAuthorizationUrl = (state: string) => {
    return `${LINKEDIN_API_CONFIG.AUTHORIZATION_URL}?response_type=${LINKEDIN_API_CONFIG.RESPONSE_TYPE}&client_id=${LINKEDIN_API_CONFIG.CLIENT_ID}&state=${state}&redirect_uri=${getRedirectUri()}&scope=${LINKEDIN_API_CONFIG.SCOPE}`;
};
